import { WHATSAPP_SUPPORTED_COUNTRIES_LOADING, WHATSAPP_SUPPORTED_COUNTRIES_SUCCESS, WHATSAPP_SUPPORTED_COUNTRIES_FAILED } from '../actions/whatsappPlans.action'
import { WhatsappSupportedCountriesReducer } from '../models/whatsappSupportedCountries.interface'


const initialState: WhatsappSupportedCountriesReducer = {
    whatsappSupportedCountriesData: [],
    whatsappSupportedCountriesLoading: false,
    whatsappSupportedCountriesError: false
}

const whatsappSupportedCountriesReducer = (state: WhatsappSupportedCountriesReducer = initialState, action: any): WhatsappSupportedCountriesReducer => {

    switch (action.type) {
        case WHATSAPP_SUPPORTED_COUNTRIES_LOADING:
            return {
                ...state,
                whatsappSupportedCountriesLoading: true,
                whatsappSupportedCountriesError: false
            }
        case WHATSAPP_SUPPORTED_COUNTRIES_SUCCESS:
            return {
                ...state,
                whatsappSupportedCountriesLoading: false,
                whatsappSupportedCountriesError: false,
                whatsappSupportedCountriesData: action.payload.res.data
            }
        case WHATSAPP_SUPPORTED_COUNTRIES_FAILED:
            return {
                ...state,
                whatsappSupportedCountriesLoading: false,
                whatsappSupportedCountriesError: true,
            }
        default:
            return state;
    }
}

export default whatsappSupportedCountriesReducer;